import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "BREAKING",
  "MCLAREN 570S HYDROPLANES ON KICK STREAM",
  "DO NOT CROSS",
  "KICK BAN — AGAIN",
  "LIVE FROM THE FLORIDA MANSION",
  "MCKINLEY IS ACTUALLY OLDER",
  "$JACK COIN — COFFEEZILLA WATCH",
  "DUMBEST MAN ONLINE?",
];

export const CautionMarquee = ({
  speed = 60,
  background = "#FFEA00",
  color = "#000",
  direction = "left",
  reverse,
  className = "",
}) => {
  return (
    <div
      className={`relative brutal-border-y marquee-row ${className}`}
      style={{ background }}
      data-testid="caution-marquee"
    >
      <Marquee
        gradient={false}
        speed={speed}
        pauseOnHover
        direction={reverse ? "right" : direction}
      >
        {items.concat(items).map((t, i) => (
          <span
            key={`${t}-${i}`}
            className="inline-flex items-center text-[22px] md:text-[28px] font-bold uppercase px-6 py-2"
            style={{ color }}
          >
            <span className="mx-3 inline-block w-4 h-4 bg-black" />
            {t}
          </span>
        ))}
      </Marquee>
    </div>
  );
};
